import React from "react";
import type { Feature } from "../../types/content";
import { SectionHeading } from "./SectionHeading";
type FeatureGridProps = {
  id: string;
  eyebrow: string;
  title: string;
  intro?: string;
  items: Feature[];
  note?: string;
  background?: "white" | "soft";
};
export function FeatureGrid({
  id,
  eyebrow,
  title,
  intro,
  items,
  note,
  background = "white"
}: FeatureGridProps) {
  return <section className={`${background === "soft" ? "bg-soft" : "bg-white"} py-8 lg:py-14`} aria-labelledby={id} data-id="element-180" data-mp="2fc7opj92szul">
      <div className="mx-auto max-w-[1320px] px-5 lg:px-10" data-id="element-181" data-mp="2jecaxwx72u77">
        <SectionHeading id={id} eyebrow={eyebrow} title={title} intro={intro} data-id="element-182" data-mp="2ocdvyne6l3lb" />
        <div className="mt-10 grid auto-rows-fr gap-px overflow-hidden rounded-lg border border-line bg-line sm:grid-cols-2 lg:grid-cols-3" data-id="element-183" data-mp="2oegrto20lqxy">
          {items.map(item => <article key={item.title} className="flex flex-col bg-white p-7" data-id="element-184" data-mp="3ln2xx160f6o">
              <h3 className="text-lg font-bold tracking-tight text-ink" data-id="element-185" data-mp="8k6v4f6cqn7h">{item.title}</h3>
              <p className="mt-3 text-sm leading-6 text-muted" data-id="element-186" data-mp="adfqvdsjcmes">{item.text}</p>
            </article>)}
        </div>
        {note && <p className="mt-5 text-xs leading-5 text-muted" data-id="element-187" data-mp="6ccamq6ksod1">{note}</p>}
      </div>
    </section>;
}